/* eslint-disable react/prop-types */
import React, { Fragment, useState, useContext, memo, useEffect } from "react";
// Project File Imports
import Menu from "./Menu";

// Material UI Imports
import SideScreenContext from "./Contexts/SideScreenContext";
import SideScreen from "./SideScreen";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Main from "./Main/Main";
import { useLocation, useParams } from "react-router";
import AuthContext from "./Contexts/AuthenticationContext";
import RefreshMenuItemContext from "./Contexts/RefreshMenuItemContext";
import { Box } from "@mui/material";
import Loader from "../genericComponents/Loader";
import FabButton from "./Fab/FabButton";
import FabContext from "./Contexts/FabContext";

const App = ({
  getRoutes,
  onSearch,
  getAppbarOptions,
  getMenuItems,
  toggleDarkmode,
  getAvatarMenuItems,
  getLogos,
}) => {
  const [appFabItems, setAppFabItems] = useState({});
  const params = useParams();
  const { user } = useContext(AuthContext);
  const [sideScreens, setSideScreens] = useState([]);
  const [swapMenuWidth, setSwapMenuWidth] = useState();
  const theme = useTheme();
  const [logos, setLogos] = useState();
  const [menuItems, setMenuItems] = useState();
  const [routes, setRoutes] = useState();
  const [appbarOptions, setAppbarOptions] = useState();
  const [avatarMenuItems, setAvatarMenuItems] = useState();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState();
  const [menuItemsRetryDone, setMenuItemsRetryDone] = useState(false);
  const isLgOrXL = useMediaQuery(theme.breakpoints.up("md"));
  const isXs = useMediaQuery(theme.breakpoints.down("sm"));
  const menuMinWidth = theme.menuMinWidth ? theme.menuMinWidth : 52;
  let menuMaxWidth = theme.menuMaxWidth ? theme.menuMaxWidth : 320;
  //Calculate Widths
  let menuWidth = 0;
  let loadingWhat = "";
  if (isLgOrXL) {
    menuWidth = !swapMenuWidth ? menuMaxWidth : menuMinWidth;
  }
  const location = useLocation();
  useEffect(() => {
    setAppFabItems({});
  }, [location]);
  
  // Load menu items, routes, etc. only once when user is available
  useEffect(() => {
    if (!menuItems && user) {
      getMenuItems({ callback: setMenuItems, user, params });
    }
  }, [menuItems, user, params, getMenuItems]);

  useEffect(() => {
    if (!routes && user) {
      getRoutes({ callback: setRoutes, user, params });
    }
  }, [routes, user, params, getRoutes]);

  useEffect(() => {
    if (!logos && user) {
      getLogos({ callback: setLogos, user, params });
    }
  }, [logos, user, params, getLogos]);

  useEffect(() => {
    if (!avatarMenuItems && user) {
      getAvatarMenuItems({ callback: setAvatarMenuItems, user, params });
    }
  }, [avatarMenuItems, user, params, getAvatarMenuItems]);

  useEffect(() => {
    if (!appbarOptions && user) {
      getAppbarOptions({ callback: setAppbarOptions, user, params });
    }
  }, [appbarOptions, user, params, getAppbarOptions]);
  //Calculate heights
  let appBarHeight = theme.appBarHeight ? theme.appBarHeight : 64;
  if (isXs && mobileSearchOpen) {
    appBarHeight = appBarHeight * 2;
  }

  const refreshFunction = () =>
    getMenuItems({ callback: setMenuItems, user: user, params: params });

  let isReady = true;
  if (!menuItems) { isReady = false; loadingWhat += "Menu "; }
  if (!routes) { isReady = false; loadingWhat += "Routes "; }
  if (!logos) { isReady = false; loadingWhat += "Logos "; }
  if (!avatarMenuItems) { isReady = false; loadingWhat += "Avatar "; }
  if (!appbarOptions) { isReady = false; loadingWhat += "Appbar "; }

  if (!isReady) {
    return (
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader text={"Loading: " + loadingWhat + "..."} />
      </Box>
    );
  }
  const arraysEqual = (a, b) => {
    return JSON.stringify(a) == JSON.stringify(b);
  };
  const setFabItems = ({ key, items }) => {
    if (arraysEqual(appFabItems[key], items)) {
      return;
    }
    setAppFabItems({ ...appFabItems, [key]: items });
  };

  const currentFapItems = [];
  if (appFabItems) {
    for (const [key, value] of Object.entries(appFabItems)) {
      if (value) {
        currentFapItems.push(...value);
      }
    }
  }
  return (
    <FabContext.Provider value={{ setFabItems: setFabItems }}>
      <RefreshMenuItemContext.Provider value={{ refresh: refreshFunction }}>
        <SideScreenContext.Provider
          value={{
            sideScreens: sideScreens,
            setSideScreens: setSideScreens,
          }}
        >
          <div style={{ display: "flex", height: "100vh" }}>
            <Menu
              logos={logos}
              avatarMenuItems={avatarMenuItems}
              swapMenuWidth={swapMenuWidth}
              menuItems={menuItems}
              width={menuWidth}
              maxWidth={menuMaxWidth}
              swapMenu={() => setSwapMenuWidth(!swapMenuWidth)}
              isOpen={mobileMenuOpen}
              onOpen={() => setMobileMenuOpen(true)}
              onClose={() => setMobileMenuOpen(false)}
            />
            <Main
              onSearch={onSearch}
              toggleDarkmode={toggleDarkmode}
              menuWidth={menuWidth}
              appbarOptions={appbarOptions}
              routes={routes}
              mobileSearchOpen={mobileSearchOpen}
              avatarMenuItems={avatarMenuItems}
              mobileMenuOpen={mobileMenuOpen}
              setMobileMenuOpen={setMobileMenuOpen}
              setMobileSearchOpen={setMobileSearchOpen}
            />
            <SideScreen sideScreens={sideScreens} appBarHeight={appBarHeight} />
            <FabButton items={currentFapItems} />
          </div>
        </SideScreenContext.Provider>
      </RefreshMenuItemContext.Provider>
    </FabContext.Provider>
  );
};

export default App;
